<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      width="300"
    >
      <v-list nav>
        <template
          v-for="item in sideMenu"
        >
          <v-list-group
            v-if="item.nested"
            :key="item.text"
            :prepend-icon="item.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>
            <template v-for="nestedItem in item.nested">
              <v-list-group
                v-if="nestedItem.nested"
                :key="nestedItem.text"
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">
                      {{ nestedItem.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="doubleNestedItem in nestedItem.nested"
                  :key="doubleNestedItem.text"
                  :to="typeof doubleNestedItem.to !== 'undefined' ? { name: doubleNestedItem.to, params: { lang: $i18n.locale } } : undefined"
                  :href="typeof doubleNestedItem.href !== 'undefined' ? doubleNestedItem.href : undefined"
                  exact
                >
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">
                      {{ $t(doubleNestedItem.text) }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon>{{ doubleNestedItem.icon }}</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list-group>
              <v-list-item
                v-else
                :key="nestedItem.text"
                :to="typeof nestedItem.to !== 'undefined' ? { name: nestedItem.to, params: { lang: $i18n.locale } } : undefined"
                :href="typeof nestedItem.href !== 'undefined' ? nestedItem.href : undefined"
                exact
              >
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ $t(nestedItem.text) }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>{{ nestedItem.icon }}</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            :to="typeof item.to !== 'undefined' ? { name: item.to, params: { lang: $i18n.locale } } : undefined"
            :href="typeof item.href !== 'undefined' ? item.href : undefined"
            exact
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                {{ $t(item.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template v-slot:append>
        <v-divider />

        <div class="px-4 py-2 hidden-sm-and-up">
          <button-change-theme />
          <button-welcome-audio />
        </div>
        <project-logo
          :light-logo="projectLogoVerticalLight"
          :dark-logo="projectLogoVerticalDark"
          class="hidden-md-and-down"
        />
      </template>
    </v-navigation-drawer>
    <v-app-bar
      id="app-toolbar"
      app
      clipped-left
      fixed
    >
      <v-app-bar-nav-icon
        :aria-label="$t('app.showHideMenu')"
        @click.stop="drawer = !drawer"
      />
      <router-link
        :to="{ name: 'home', params: { lang: $i18n.locale } }"
        :aria-label="$t('app.navigateToHomepage')"
      >
        <v-img
          v-if="TERYT"
          :src="`${publicPath}img/coa/svg/${TERYT}.svg`"
          :alt="$t('app.coa')"
          contain
          transition="scale-transition"
          height="42px"
          width="42px"
        />
      </router-link>
      <v-toolbar-title class="title">
        <span class="hidden-xs-only">{{ $t('app.title') }}</span>
        <span class="hidden-sm-and-up">Geoportal</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :aria-label="$t('app.geoportal2URL')"
              class="hidden-xs-only"
              href="https://www.geoportal2.pl"
              icon
              v-on="on"
            >
              <v-img
                :src="require(`@/assets/img/logoGeoportal2.svg`)"
                :alt="$t('app.coa')"
                contain
                transition="scale-transition"
                height="28px"
                width="28px"
              />
            </v-btn>
          </template>
          <span>{{ $t('app.geoportal2URL') }}</span>
        </v-tooltip>
        <button-change-theme class="hidden-xs-only" />
        <button-welcome-audio class="hidden-xs-only" />
        <language-selector />
      </v-toolbar-items>
    </v-app-bar>
    <v-main>
      <v-fade-transition mode="out-in">
        <router-view :key="$route.fullPath" />
      </v-fade-transition>
    </v-main>
    <v-footer
      fixed
    >
      <v-spacer />
      <div
        class="text-center"
      >
        &copy; {{ new Date().getFullYear() }}
        <a
          href="https://geobid.pl"
          rel="noopener"
        >GEOBID</a>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
export default {
  // TODO usunąć items i zrobić w formie osobnego pliku w api
  name: 'App',
  components: {
    ProjectLogo: () => import('@/components/Utility/ProjectLogo.vue'),
    LanguageSelector: () => import('@/components/Utility/LanguageSelector.vue'),
    ButtonWelcomeAudio: () => import('@/components/Utility/ButtonWelcomeAudio.vue'),
    ButtonChangeTheme: () => import('@/components/Utility/ButtonChangeTheme.vue')
  },
  data: () => ({
    drawer: undefined,
    publicPath: process.env.BASE_URL,
    sideMenu: undefined
  }),
  computed: {
    ...mapState('settings', {
      TERYT: state => state.TERYT,
      projectLogoVerticalLight: state => state.projectLogoVerticalLight,
      projectLogoVerticalDark: state => state.projectLogoVerticalDark
    }),
    darkMode: {
      get () {
        return this.$store.state.darkMode
      },
      set (value) {
        this.$store.commit('setDarkMode', value)
      }
    }
  },
  created () {
    axios
      .get(`${this.publicPath}api/sideMenu.json`)
      .then(response => (this.sideMenu = response.data))
    this.loadSettings(`${this.publicPath}api/settings.json`)
    this.loadGeoportals({ config: 'geoportals', filePath: `${this.publicPath}api/geoportals.json` })
    this.loadGeoportals({ config: 'gminy', filePath: `${this.publicPath}api/gminy.json` })
    this.configureDarkMode()
  },
  methods: {
    ...mapActions(['loadGeoportals']),
    ...mapActions('settings', [
      'loadSettings' // -> this.loadSettings()
    ]),
    configureDarkMode: function () {
      if (typeof this.darkMode === 'undefined') {
        this.darkMode = !window.matchMedia('(prefers-color-scheme: light)').matches
        // Check if light color is applied if not or none set dark as true
      }
      this.$vuetify.theme.dark = this.darkMode // Refresh Vuetify color
    }
  }
}
</script>

<style lang="sass">
  @import 'sass/variables'

  #app-toolbar
    .v-toolbar__title
      margin-left: .5em
</style>
